// Role updates (ADR 0031): permissions a release added to the standard roles, offered to
// this organisation's roles for an administrator to accept or decline.
import { queryOptions } from '@tanstack/react-query';
import { rolePermissionOffersListSchema, type DecideRolePermissionOffersBody } from '@wodi/shared';

import { api } from './client.ts';

export const roleOffersQuery = queryOptions({
  queryKey: ['roles', 'permission-offers'] as const,
  queryFn: () => api('GET', '/roles/permission-offers', { schema: rolePermissionOffersListSchema }),
});

export const decideRoleOffers = (roleId: string, body: DecideRolePermissionOffersBody) =>
  api('POST', `/roles/${roleId}/permission-offers`, {
    body,
    schema: rolePermissionOffersListSchema,
  });

/** "New permissions are available for 3 roles." */
export function offersSentence(roleCount: number): string {
  return roleCount === 1
    ? 'New permissions are available for 1 role.'
    : `New permissions are available for ${String(roleCount)} roles.`;
}
